<app-landing-header></app-landing-header>
  <section>
    <div id="slider" class="relative w-full h-[500px] overflow-hidden" style="height: 570px;">
      <!-- Imagen dinámica -->
      <img id="slideImage"
        src="https://griky.matrixlms.com/files/8330398/carousel-1(4).png?lmsauth=b5c25b4f1b701cf02a1352729bbadfeb61b74195"
        class="absolute top-0 left-0 w-full h-full object-cover z-0 " alt="slide image" />

      <!-- Texto dinámico -->
      <div class="relative z-10 h-full flex items-center mx-auto w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]">
        <div id="slideText" class="text-white w-full sm:w-1/2">
          <h2 class="text-4xl font-bold drop-shadow-md">Welcome to Griky</h2>
          <p class="text-lg mt-2 drop-shadow-md">
            This is our e-learning portal,
            powered by CYPHER Learning.</p>
        </div>
      </div>

      <!-- Botones (opcional) -->
      <button id="prev" class="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-3xl z-20 hidden">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <button id="next" class="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-3xl z-20 hidden">
        <i class="fa-solid fa-chevron-right"></i>
      </button>

      <!-- Overlay oscuro -->
      <div class="absolute inset-0 bg-black bg-opacity-40 z-0"></div>
    </div>
  </section>


  <!-- Cards Section -->
  <section class="py-12" id="catalogo" style="margin-top: 5rem;">
    <div class="mx-auto w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%] px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-center">

      <!-- Card -->
      <div
        class="bg-transparent p-6 rounded-xl  transition duration-300 ease-in-out transform hover:-translate-y-2 hover:bg-white hover:shadow-lg flex flex-col items-center h-full border-none">
        <img src="../../../../assets/images/landing/card-inicio-1.jpg" class="rounded-full w-32 h-32 object-cover mb-4" />
        <h3 class="text-lg font-semibold mb-2">Captivating courses</h3>
        <p class="text-gray-500 mb-4">Interactive courses will keep learners engaged and they will be able to learn at a
          faster pace.</p>
        <div class="mt-auto">
          <button class="btn-cards-page rounded-lg bg-primary text-white px-4 py-2 text-sm">View Catalag</button>
        </div>
      </div>

      <!-- Card -->
      <div
        class="bg-transparent p-6 rounded-xl transition duration-300 ease-in-out transform hover:-translate-y-2  hover:bg-white hover:shadow-lg flex flex-col items-center h-full border-none">
        <img src="../../../../assets/images/landing/card-inicio-2.png" class="rounded-full w-32 h-32 object-cover mb-4" />
        <h3 class="text-lg font-semibold mb-2">Professional instructors</h3>
        <p class="text-gray-500 mb-4">We have the best instructors in the region. Learn more about them.</p>
        <div class="mt-auto">
          <button class="btn-cards-page rounded-lg bg-primary text-white px-4 py-2 text-sm">About Griky</button>
        </div>
      </div>

      <!-- Card -->
      <div
        class="bg-transparent p-6 rounded-xl  transition duration-300 ease-in-out transform hover:-translate-y-2 hover:bg-white hover:shadow-lg flex flex-col items-center h-full border-none">
        <img src="../../../../assets/images/landing/card-inicio-3.png" class="rounded-full w-32 h-32 object-cover mb-4" />
        <h3 class="text-lg font-semibold mb-2">Subscribe and Never Miss Out</h3>
        <p class="text-gray-500 mb-4">Griky has exciting activities planned for all of 2025.
          Subscribe now to stay updated on upcoming events and news!</p>
        <div class="mt-auto">
          <button class="btn-cards-page rounded-lg bg-primary text-white px-4 py-2 text-sm">Subscribe Now</button>
        </div>
      </div>

      <!-- Card -->
      <div
        class="bg-transparent p-6 rounded-xl  transition duration-300 ease-in-out transform hover:-translate-y-2 hover:bg-white hover:shadow-lg flex flex-col items-center h-full border-none">
        <img src="../../../../assets/images/landing/card-inicio-4.jpg" class="rounded-full w-32 h-32 object-cover mb-4" />
        <h3 class="text-lg font-semibold mb-2">Enroll with us</h3>
        <p class="text-gray-500 mb-4">Don't hesitate to ask us a question. We're happy to help.</p>
        <div class="mt-auto">
          <button class="btn-cards-page rounded-lg bg-primary text-white px-4 py-2 text-sm">Contact</button>
        </div>
      </div>

    </div>
  </section>

  <app-footer></app-footer>

  
 